import {
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { Fragment, useState } from "react";
import { useRefresh, useNotify, useMutation, Button } from "react-admin";
import SaveIcon from "@material-ui/icons/Save";
import { StyledButton } from "../../../components/ListShowButton";

interface IRejectButton {
  id: number;
}

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
  table: {
    marginTop: "10px",
    minWidth: 650,
    padding: "1rem",
  },
});

const CustomConfirmButton = ({ id }: IRejectButton) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const [handleReject, { loading }] = useMutation(
    {
      type: "customUpdate",
      resource: `subcontractorAdhocFees/${id}/reject`,
      payload: {},
    },
    {
      onSuccess: () => {
        notify(`Successfully reject adhoc fee.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(`Failed reject adhoc fee, error: ${error.message}`, "warning"),
    }
  );

  return (
    <Button
      onClick={handleReject}
      color="primary"
      label={loading ? "Please wait..." : "Confirm"}
      autoFocus
    >
      <SaveIcon />
    </Button>
  );
};

const RejectButton = ({ id }: IRejectButton) => {
  const [open, setOpen] = useState<boolean>(false);

  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <StyledButton
        variant="outlined"
        onClick={handleOpenDialog}
        style={{ color: "#DA4040", borderColor: "#DA4040" }}
      >
        Reject
      </StyledButton>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">Reject The Adhoc Fee</DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            Are you sure you want to reject the adhoc fee?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
          <CustomConfirmButton id={id} />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default RejectButton;
